@if (!hasNestedItems) {
  <a
    class="sidebar__item parent"
    [class.closed]="!isSidebarOpen()"
    [class.active]="itemText() === activeItem()"
    [routerLink]="link()">
    <i class="sidebar__item-icon" [ngClass]="icon()"></i>
    @if (isSidebarOpen()) {
      <span class="sidebar__item-text" @regularFontSizeAnimation>{{ itemText() }}</span>
    }
  </a>
} @else {
  <span class="sidebar__item parent" [class.closed]="!isSidebarOpen()" [class.active]="isParentActive()" [routerLink]="link()">
    <i class="sidebar__item-icon" [ngClass]="icon()"></i>
    @if (isSidebarOpen()) {
      <span class="sidebar__item-text" @regularFontSizeAnimation>{{ itemText() }}</span>
    }
  </span>
  @for (item of nestedItems(); track $index) {
    @if (item.isShownForUser) {
      <a
        class="sidebar__item child"
        [class.closed]="!isSidebarOpen()"
        [class.active]="isChildActive(item.itemText)"
        [routerLink]="item.link"
        (click)="onNestedItemClick(item.itemText)">
        <i class="sidebar__item-icon" [ngClass]="item.icon"></i>
        @if (isSidebarOpen()) {
          <span class="child-item-text" @regularFontSizeAnimation>{{ item.itemText }}</span>
        } @else {
          <i class="sidebar__item-child-icon" [ngClass]="'pi pi-circle-fill'"></i>
        }
      </a>
    }
  }
}
